var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 0.833496H9.33329V2.50016H12.6666C14.0416 2.50016 15.1666 3.62516 15.1666 5.00016C15.1666 6.37516 14.0416 7.50016 12.6666 7.50016H9.33329V9.16683H12.6666C14.9666 9.16683 16.8333 7.30016 16.8333 5.00016C16.8333 2.70016 14.9666 0.833496 12.6666 0.833496ZM7.66663 7.50016H4.33329C2.95829 7.50016 1.83329 6.37516 1.83329 5.00016C1.83329 3.62516 2.95829 2.50016 4.33329 2.50016H7.66663V0.833496H4.33329C2.03329 0.833496 0.166626 2.70016 0.166626 5.00016C0.166626 7.30016 2.03329 9.16683 4.33329 9.16683H7.66663V7.50016ZM5.16663 4.16683H11.8333V5.8335H5.16663V4.16683Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachImage);
export default __webpack_public_path__ + "static/media/attachImage.f38cd786b9c4a339c097434d8f695660.svg";
export { ForwardRef as ReactComponent };